var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaGewichtsverlauf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#59667c;}.cls-3{fill:#3b485e;}.cls-4{fill:#fff;}.cls-5{fill:#ea5c0b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.18,152H18.7A10.74,10.74,0,0,1,8,141.29V18.71A10.74,10.74,0,0,1,18.7,8H141.18a10.74,10.74,0,0,1,10.71,10.71V141.18A10.7,10.7,0,0,1,141.18,152Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.9,22.46A107.91,107.91,0,0,0,35.36,32.1L57.12,61.75A73.92,73.92,0,0,1,80.05,58,70.7,70.7,0,0,1,103,61.75L124.74,32.1A110.38,110.38,0,0,0,79.9,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.9,21a103.9,103.9,0,0,0-43.23,9.35l21,28.77a69.34,69.34,0,0,1,44.4,0l21-28.77A103.86,103.86,0,0,0,79.9,21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 78.44,
    y: 23.05,
    width: 3.07,
    height: 28.92
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaGewichtsverlauf);
export default __webpack_public_path__ + "static/media/ka_gewichtsverlauf.73fbdd337995cee03ecc45a9adf624eb.svg";
export { ForwardRef as ReactComponent };